import { isUndefined } from 'lodash-es';

import { THRESHOLD_COLOR_DEFAULT } from '../types/default.js';
import type { MeterBarChartThresholdPropsInternal } from '../types/meter-bar-chart-internal.js';
import type { MeterBarChartThresholdProps } from '../types/meter-bar-chart.js';

export const applyThresholdDefaults = (
  threshold: MeterBarChartThresholdProps,
): MeterBarChartThresholdPropsInternal => {
  const showIndicatorDefault = isUndefined(threshold.color) ? true : false;

  return {
    value: threshold.value,
    name: threshold.name,
    color: threshold.color ?? THRESHOLD_COLOR_DEFAULT,
    showIndicator: threshold.showIndicator ?? showIndicatorDefault,
  };
};
